<template>
  <div class="flex justify-center items-center h-full w-full">
    <div class="max-w-md w-full h-full">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MobileView',
});
</script>
